/**
* Copyright Aquera Inc 2023
*
* This source code is licensed under the BSD-3-Clause license found in the
* LICENSE file in the root directory of this source tree.
*/

import {css} from 'lit-element';

/**
 * IconButton CSS
 */
export const styles = css`

:host {
    display: inline-block;
    color: hsl(240 5.2% 33.9%);
  }

  .icon-button {
    flex: 0 0 auto;
    display: flex;
    align-items: center;
    background: none;
    border: none;
    border-radius: 0.25rem;
    font-size: inherit;
    color: inherit;
    padding: 0.5rem;
    cursor: pointer;
    transition: 50ms; color;
    -webkit-appearance: none;
  }

  .icon-button:hover:not(.icon-button--disabled),
  .icon-button:focus-visible:not(.icon-button--disabled) {
    color: hsl(200.4 98% 39.4%);
  }

  .icon-button:active:not(.icon-button--disabled) {
    color: hsl(201.3 96.3% 32.2%);
  }

  .icon-button:focus {
    outline: none;
  }

  .icon-button--disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  .icon-button:focus-visible {
    outline: hsl(200.4 98% 39.4%);
    outline-offset: 1px;
  }

  .icon-button__icon {
    pointer-events: none;
  }
`;

export default [styles];
